import React from 'react';
import { View, ScrollView } from 'react-native';

import Modal from './shared/Modal';
import ThingItem, { SmallSlot } from './common/ThingItem';
import heroStore from '../stores/hero';
import { t } from '../utils/appUtils';
import { pOrT, MARGIN_10, MARGIN_15, MARGIN_25 } from './styleConstants';
import { BonusType } from '../lib/types';

type DroppedModalProps = {
  bonus: BonusType;
  onHide: () => void;
};

const DroppedModal = ({ bonus, onHide }: DroppedModalProps) => {
  const { money, things: bonusThings } = bonus;

  return (
    <Modal
      size={{
        width: pOrT(500, 600),
        height: pOrT(280, 420),
      }}
      title={t('combat.dropped')}
      onHide={onHide}
    >
      <ScrollView style={{ marginTop: 40, marginBottom: 25 }}>
        {money ? (
          <View style={{ marginLeft: MARGIN_25 }}>
            <SmallSlot money={money} />
          </View>
        ) : null}
        {bonusThings
          ? bonusThings.map((bonusThing) => (
              <View
                key={bonusThing.thing}
                style={{
                  marginTop: MARGIN_10,
                  marginLeft: pOrT(undefined, MARGIN_15),
                  alignItems: 'center',
                }}
              >
                <ThingItem
                  warrior={heroStore.hero}
                  warriorThingOrId={bonusThing.thing}
                  width={pOrT(450, 550)}
                />
              </View>
            ))
          : null}
      </ScrollView>
    </Modal>
  );
};

export default DroppedModal;
